import { render } from "./FieldsetsStepFour.vue?vue&type=template&id=51927a15"
import script from "./FieldsetsStepFour.vue?vue&type=script&lang=js"
export * from "./FieldsetsStepFour.vue?vue&type=script&lang=js"

import "./FieldsetsStepFour.vue?vue&type=style&index=0&id=51927a15&lang=css"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__